const actionItemsListingTransformHelper = response => {
  const resp = {
    ...response,
    statistics: {
      all: response.statistics.all,
      completed: response.statistics.completed,
      incomplete: response.statistics.pending,
      overdue: response.statistics.overdue,
    },
  }

  return resp
}

export default actionItemsListingTransformHelper
